export default "__VITE_ASSET__TDzeTtUJ__"